import { Check } from "lucide-react";

export const DoneStamp = ({ small = false, testId = "quest-done-stamp" }) => (
  <span className={`quest-stamp ${small ? "quest-stamp-sm" : ""}`} data-testid={testId} aria-label="Erledigt">
    <Check className={small ? "w-3.5 h-3.5" : "w-7 h-7"} strokeWidth={3.5} /> Erledigt
  </span>
);
